<template>
<div class="px-1 pt-1">
  <div class="input-group pb-3">
    <button class="btn btn-outline-secondary" @click="refresh()" :disabled="isLoading">
      <div v-if="isLoading" class="spinner-border spinner-border-sm"></div>
      <font-awesome-icon v-else :icon="['fas', 'rotate']" />
      <span class="d-none d-sm-inline">{{ $t('action.refresh') }}</span>
    </button>
    <button class="btn btn-outline-primary" @click="routeToCreateView()">
      <font-awesome-icon :icon="['fas', 'cart-shopping']" />
      {{ $t('action.newEllipsis') }}
    </button>
    <div class="form-check m-2">
      <input class="form-check-input" type="checkbox" v-model="showPast" id="showPast">
      <label class="form-check-label" for="showPast">{{ $t('action.showPast') }} <span class="text-nowrap">({{ $t('global.days', 30) }})</span></label>
    </div>
  </div>

  <OrderList @selected="goToOrder" :show-past="showPast" :statuses="statuses" />
</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { router } from "@/services";
import { useOrdersStore } from '@/stores';
import OrderList from "@/components/orders/OrderList.vue";
import { ORDER_HEAD_STATUS } from '@/models/Enums';

const showPast = ref(false);

const statuses = [ORDER_HEAD_STATUS.pending, ORDER_HEAD_STATUS.inProgress];

const ordersStore = useOrdersStore();
const { isLoading } = storeToRefs(ordersStore);

const goToOrder = async (orderId: number) => {
  await router.push({ name: 'order', params: { orderId: orderId } });
}

const routeToCreateView = async () => {
  await router.push({ name: 'order-create' });
}

async function refresh() {
  await ordersStore.fetchAll(showPast.value, statuses);
}
</script>
